module.exports = __webpack_public_path__ + "media/images/michael_france-b1ffa4776411317b50ee138eba717fae.png";